import { render, staticRenderFns } from "./myFile.vue?vue&type=template&id=2dc54d3c&"
import script from "./myFile.vue?vue&type=script&lang=js&"
export * from "./myFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports